import { render, staticRenderFns } from "./wang.vue?vue&type=template&id=28bd9384&"
import script from "./wang.vue?vue&type=script&lang=ts&"
export * from "./wang.vue?vue&type=script&lang=ts&"
import style0 from "./wang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports